// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H7.33057L7.33057 22H2V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.33471 2H14.6653V22H9.33471V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H16.6694V22H22V2Z"}}]};

const Frame1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'frame-1-filled',
    ref,
    icon: element,
  },
));

Frame1FilledIcon.displayName = 'Frame1FilledIcon';

export default Frame1FilledIcon;
